import React, { useEffect, useState } from 'react'
import styles from './StoreBanner.module.scss'
import { useNavigate } from 'react-router-dom'
import { useClickAdvertBannerMutation, useGetActiveAdvertBannerQuery } from '../../../../service/advert-banner-service'
import { AdvertBanner } from '../../../../model/advert-banner/advert-banner'

type Props = {
}

const StoreBanner: React.FC<Props> = (props: Props) => {
    const navigate = useNavigate();
    const [activeBanner, setActiveBanner] = useState<AdvertBanner | null>(null);

    const { data, error, isLoading } = useGetActiveAdvertBannerQuery();
    const [clickBanner] = useClickAdvertBannerMutation();

    useEffect(() => {
        if (data) {
            setActiveBanner(data);
        }
    }, [data]);

    const handleBannerClick = async () => {
        console.log(activeBanner)
        if (activeBanner) {
            try {
                await clickBanner({ id: activeBanner.id });
                window.location.href = activeBanner.redirectUrl;
            } catch (error) {
                console.error("Error registering banner click", error);
            }
        }
    };

    return (
        <div className={styles.container} onClick={handleBannerClick}>
            {activeBanner && (
                <img 
                    src={activeBanner.pictureUrl} 
                    alt={activeBanner.name} 
                    className={styles.bannerImage}
                />
            )}
        </div>
    )
}

export default StoreBanner